'use client';

import { PopoverClose } from '@radix-ui/react-popover';
import { SlidersHorizontal, X } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

import { FiltersContent } from './filters-content';
import { FiltersDesktopHeader } from './filters-desktop-header';

type HeaderFiltersDesktopProps = {
  filterCount: number;
  clearFilters: () => void;
  handleApplyFilters: () => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const HeaderFiltersDesktop = ({
  filterCount,
  clearFilters,
  handleApplyFilters,
  isOpen,
  setIsOpen,
}: HeaderFiltersDesktopProps) => {
  return (
    <Popover open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>
        <Button
          className='relative h-10 rounded-l-none rounded-r-xl border border-l-0 border-[#D1D1D1] hover:bg-brand-soft/25 focus-visible:ring-brand-green focus-visible:ring-offset-0'
          variant='ghost'
          size='icon'
        >
          <SlidersHorizontal className='text-brand-green' size={16} />
          {filterCount > 0 && (
            <Badge
              variant='filter-count'
              className='absolute -right-1 -top-1 bg-white'
            >
              {filterCount}
            </Badge>
          )}
        </Button>
      </PopoverTrigger>
      <PopoverContent
        sideOffset={10}
        className='flex w-96 flex-col rounded-lg border bg-white p-4 shadow-lg'
        align='end'
        side='bottom'
      >
        <PopoverClose className='self-end' asChild>
          <Button className='[&_svg]:size-6' variant='ghost' size='icon-sm'>
            <X className='text-brand-dark' />
          </Button>
        </PopoverClose>
        <FiltersDesktopHeader
          count={filterCount}
          clearFilters={clearFilters}
          className='py-4'
        />
        <FiltersContent variant='desktop' className='flex flex-col' />
        <div className='bg-background pt-4'>
          <Button onClick={handleApplyFilters} className='w-full'>
            Apply Filters
          </Button>
        </div>
      </PopoverContent>
    </Popover>
  );
};
